import {
    Injectable,
    TemplateRef,
} from '@angular/core';

import {
    animationFrameScheduler,
    BehaviorSubject,
    Observable,
} from 'rxjs';
import {
    observeOn,
} from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class HeaderOverrideService {
    public readonly template$: Observable<TemplateRef<any> | null>;

    private _template$ = new BehaviorSubject<TemplateRef<any> | null>(null);

    constructor() {
        this.template$ = this._template$
            .asObservable()
            .pipe(observeOn(animationFrameScheduler));
    }

    public set(tpl: TemplateRef<any> | null) {
        this._template$.next(tpl);
    }
}
